import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { UserDto } from './dto/userDto';

export class UserService extends CrudServiceBase<UserDto> {
    constructor() {
        super(Endpoint.User);
    }
}

const exportUserCrudService: UserService = new UserService();
export default exportUserCrudService;